import GuestOnly from '@/components/auth/GuestOnly';
import RequireAuth from '@/components/auth/RequireAuth';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Schedule = lazy(() => import('../pages/schedule/page'));
const BulkSetup = lazy(() => import('../pages/bulk-setup/page'));
const Settings = lazy(() => import('../pages/settings/page'));
const Onboarding = lazy(() => import('../pages/onboarding/page'));
const EasyOnboarding = lazy(() => import('../pages/easy-onboarding/page'));
const EasyOnboarding2 = lazy(() => import('../pages/easy-onboarding2/page'));
const TimeSlotGenerator = lazy(() => import('../pages/time-slot-generator/page'));
const Login = lazy(() => import('../pages/login/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    element: <GuestOnly />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
    ],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <Schedule />,
      },
      {
        path: '/bulk-setup',
        element: <BulkSetup />,
      },
      {
        path: '/settings',
        element: <Settings />,
      },
      {
        path: '/onboarding',
        element: <Onboarding />,
      },
      {
        path: '/easy-onboarding',
        element: <EasyOnboarding />,
      },
      {
        path: '/easy-onboarding2',
        element: <EasyOnboarding2 />,
      },
      {
        path: '/time-slot-generator',
        element: <TimeSlotGenerator />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
// const routes: RouteObject[] = [
//   {
//     path: '/login',
//     element: <Login />,
//   },
  
//   {
//     path: '*',
//     element: <NotFound />,
//   },
// ];

export default routes;
